export default "__VITE_ASSET__XpzJzosJ__"